import { Stack, Typography } from '@mui/material';
import type { Tone } from './tone';
import { toneColor } from './tone';

export type KeyValue = { label: string; value: string; bold?: boolean; tone?: Tone; highlight?: boolean };

/** Label on the left, value on the right, one per line */
export function KeyValueList({ rows }: { rows: KeyValue[] }) {
  return (
    <Stack>
      {rows.map((r) => (
        <Stack
          key={r.label}
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'space-between',
            py: 0.75,
            px: r.highlight ? 1 : 0,
            borderRadius: 1,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: r.highlight ? 'action.hover' : undefined,
          }}
        >
          <Typography
            variant="body2"
            color={r.bold || r.highlight ? 'text.primary' : 'text.secondary'}
            sx={{ fontWeight: r.bold || r.highlight ? 700 : 400 }}
          >
            {r.label}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: r.bold || r.highlight || r.tone ? 700 : 500,
              textAlign: 'right',
              color: r.tone ? toneColor(r.tone) : undefined,
              overflowWrap: 'anywhere',
            }}
          >
            {r.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
